import request from 'services/axios'
import { IGateway } from 'utilities/hooks/useIsDefaultGateway'

/** A box the payment touches, in the shape the endpoint expects. */
export interface BoxRef {
    /** 'mnp' for a صندوق قرض‌الحسنه, 'cbx' for a صندوق قرعه‌کشی */
    type: 'mnp' | 'cbx'
    id: number
}

/** `mnp:34963,cbx:42293` — de-duplicated and stable, so react-query can key on it. */
export const boxesParam = (boxes: BoxRef[]): string =>
    Array.from(new Set(boxes.map((b) => `${b.type}:${b.id}`)))
        .sort()
        .join(',')

/**
 * Which gateways may actually pay for these boxes.
 *
 * `POST /api/v1/payment/init/` also returns a `gateways` key, but it answers a
 * different question and both readings of it produced a dead end (see
 * `useAvailableGateways`). This endpoint applies the rule the payment endpoint
 * enforces, so anything it returns will be accepted.
 */
export const getAvailableGateways = async (
    boxes: BoxRef[]
): Promise<IGateway[]> => {
    const query = boxesParam(boxes)
    const { data }: { data: { gateways: IGateway[] } } = await request.get(
        `/api/v2/payment/gateways/available/${query ? `?boxes=${query}` : ''}`
    )
    return data.gateways ?? []
}
